// skipcq: JS-W1028
import { useEffect, useState } from 'react';
import {
  collection,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../utils/firebase';
import {
  SCHEDULER_SCHEDULE_STATUS_REPORTS_COLLECTION,
} from '../utils/firestoreCollections';
import { buildSchedulerScheduleStatusDailyChartRowsAsc } from '../utils/schedulerScheduleStatusDailyChart';

const DAILY_REPORT_LOOKBACK_COUNT = 14;

function useSchedulerScheduleStatusDailyReports() {
  const [chartRowsAscending, setChartRowsAscending] = useState([]);
  const [reportsLoading, setReportsLoading] = useState(true);
  const [reportsError, setReportsError] = useState(null);

  useEffect(() => {
    const reportsCollection = collection(db, SCHEDULER_SCHEDULE_STATUS_REPORTS_COLLECTION);
    const reportsQuery = query(
      reportsCollection,
      where('type', '==', 'daily'),
      orderBy('date', 'desc'),
      limit(DAILY_REPORT_LOOKBACK_COUNT),
    );
    const unsubscribe = onSnapshot(
      reportsQuery,
      (snapshot) => {
        const documents = snapshot.docs.map(function mapReportDocument(documentSnap) {
          const data = documentSnap.data();
          return {
            id: documentSnap.id,
            date: typeof data.date === 'string' ? data.date : '',
            metrics: typeof data.metrics === 'object' && data.metrics !== null ? data.metrics : {},
          };
        });
        setChartRowsAscending(buildSchedulerScheduleStatusDailyChartRowsAsc(documents));
        setReportsLoading(false);
        setReportsError(null);
      },
      (subscriptionError) => {
        console.error('useSchedulerScheduleStatusDailyReports subscription error', subscriptionError);
        setReportsError(subscriptionError);
        setReportsLoading(false);
      },
    );
    return () => unsubscribe();
  }, []);

  return {
    chartRowsAscending,
    loading: reportsLoading,
    error: reportsError,
  };
}

export default useSchedulerScheduleStatusDailyReports;
